import { FilterModel, FilterOptionModel, SortAndFilterModel } from 'components/common/search-form/fields/filter-types';

export function filterSearchOptions(sortAndFilterOptions: SortAndFilterModel, searchTerm?: string): SortAndFilterModel {
  if (!searchTerm) {
    return sortAndFilterOptions;
  }

  return Object.assign({}, sortAndFilterOptions, {
    sort: sortAndFilterOptions.sort && filterFilterModel(sortAndFilterOptions.sort, searchTerm),
    hotelName: sortAndFilterOptions.hotelName && filterFilterModel(sortAndFilterOptions.hotelName, searchTerm),
    rewards: sortAndFilterOptions.rewards && filterFilterModel(sortAndFilterOptions.rewards, searchTerm),
    star: sortAndFilterOptions.star && filterFilterModel(sortAndFilterOptions.star, searchTerm),
    price: sortAndFilterOptions.price && filterFilterModel(sortAndFilterOptions.price, searchTerm),
    pricing: sortAndFilterOptions.pricing && filterFilterModel(sortAndFilterOptions.pricing, searchTerm),
    lodging: sortAndFilterOptions.lodging && filterFilterModel(sortAndFilterOptions.lodging, searchTerm),
    propertyType: sortAndFilterOptions.propertyType && filterFilterModel(sortAndFilterOptions.propertyType, searchTerm),
    regionId: sortAndFilterOptions.regionId && filterFilterModel(sortAndFilterOptions.regionId, searchTerm),
    poi: sortAndFilterOptions.poi && filterFilterModel(sortAndFilterOptions.poi, searchTerm),
    amenities: sortAndFilterOptions.amenities && filterFilterModel(sortAndFilterOptions.amenities, searchTerm),
    accessibility: sortAndFilterOptions.accessibility && filterFilterModel(sortAndFilterOptions.accessibility, searchTerm),
    travelerType: sortAndFilterOptions.travelerType && filterFilterModel(sortAndFilterOptions.travelerType, searchTerm),
    guestRating: sortAndFilterOptions.guestRating && filterFilterModel(sortAndFilterOptions.guestRating, searchTerm),
    paymentType: sortAndFilterOptions.paymentType && filterFilterModel(sortAndFilterOptions.paymentType, searchTerm),
    bedroomFilter: sortAndFilterOptions.bedroomFilter && filterFilterModel(sortAndFilterOptions.bedroomFilter, searchTerm),
    propertyStyle: sortAndFilterOptions.propertyStyle && filterFilterModel(sortAndFilterOptions.propertyStyle, searchTerm)
  });
}

function filterOptionMatchesSearch(filterOption: FilterOptionModel, searchTerm: string): boolean {
  return (
    filterOption.selected ||
    (filterOption.name && contains(filterOption.name, searchTerm)) ||
    (filterOption.value && contains(filterOption.value, searchTerm)) ||
    (filterOption.label && contains(filterOption.label, searchTerm)) ||
    (filterOption.ariaLabel && contains(filterOption.ariaLabel, searchTerm)) ||
    (filterOption.description && contains(filterOption.description, searchTerm))
  );
}

function contains(word: string, subString: string): boolean {
  if (!subString) {
    return true;
  }

  return word && word.toLowerCase().indexOf(subString.toLowerCase()) > -1;
}

function filterFilterModel(filterModel: FilterModel, searchTerm): FilterModel {
  if (!searchTerm) {
    return filterModel;
  }
  if (
    (filterModel.name && contains(filterModel.name, searchTerm)) ||
    (filterModel.label && contains(filterModel.label, searchTerm)) ||
    (filterModel.subLabel && contains(filterModel.subLabel, searchTerm)) ||
    (filterModel.placeholder && contains(filterModel.placeholder, searchTerm))
  ) {
    return filterModel;
  }

  const filteredOptions = filterModel.options.filter(option => filterOptionMatchesSearch(option, searchTerm));

  return (
    filteredOptions &&
    filteredOptions.length > 0 &&
    Object.assign({}, filterModel, {
      options: filteredOptions
    })
  );
}
